import { Add } from "@material-ui/icons";
import React, { useEffect } from "react";
import { useState } from "react";
import { v4 as uuid } from "uuid";

import styled from "styled-components";
import Footer from "../../components/landing_page_components/footer/Footer";

import rootStore from "../../stores/RootStore";
import { observer } from "mobx-react-lite";
import { SegmentListColumns } from "../../Db";
import { getSegmentsApi } from "../../Api";
import { Button, Drawer, Tooltip } from "@material-ui/core";
import PaginationComponent from "../../components/pagination/PaginationComponent";
import { pageSize } from "../../Config";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import SegmentRowComponent from "../../components/import_row_component/SegmentRowComponent";
import analytics from "../../Analytics";
import CreateSegmentSidePanel from "../../components/market_modals/CreateSegmentSidePanel";
import LoadingAnimationComponent from "../../components/loading_component/LoadingAnimationComponent";
const Container = styled.div`
  margin-top: 64px;
  background-color: #f9f9fc;
  ${`min-height: calc(100vh - 221px);`};
`;
const Wrapper = styled.div`
  width: 95%;
  margin: auto;
  /* background-color: white; */
  display: flex;
  flex-direction: column;
  /* padding-top: 20px; */
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 10px;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  min-height: 40px;
  padding: 20px 0px;
`;

const get_leads_url = process.env.REACT_APP_API_BASE_URL;
const Text = styled.p`
  margin: 0px;
  font: normal normal 600 12px Open Sans;
  color: #4d4e4f;
`;
const TopWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const Header = styled.p`
  margin: 0px;
  font: normal normal 600 28px Open Sans;
  /* text-align: center; */
  color: #4d4e4f;
`;
const TableWrapper = styled.div`
  width: 100%;
  ${`min-height: calc(100vh - 272px);`};
  background-color: white;
  overflow-x: auto;
  border: 2px solid #e0e0e0;
`;
const PaginationWrapper = styled.div`
  padding: 0px 20px;
`;
const EmptyTableWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
const EmptyText = styled.p`
  margin: 0px;
  font: normal normal 500 14px Open Sans;
  /* text-align: center; */
  color: #4d4e4f;
  margin-top: 50px;
`;
const ButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;
const SerialRow = [
  {
    field: "id",
    headerName: <Text>ID</Text>,
    sortable: false,

    width: 70,
    renderCell: (params) => {
      return (
        <>
          <Tooltip title={params.row.id}>
            <span className="csutable-cell-trucate">{params.row.id}</span>
          </Tooltip>
        </>
      );
    },
  },
];
const ReportsPage = () => {
  const { authStore } = rootStore;
  const [row, setRow] = useState([]);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(pageSize);
  const [openCreateSegmentForm, setOpenCreateSegmentForm] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);

  const getSegments = async ({ page_size, page }) => {
    setRow([]);
    setLoading(true);
    let response = await getSegmentsApi({
      page_size: page_size,
      page: page,
    });
    if (Object.keys(response).length > 0) {
      setRow(response.items);
      setCount(response.item_count);
    } else {
      setCount(0);
    }
    setLoading(false);
  };
  const init = async () => {
    await getSegments({ page_size: pageSize, page: 0 });
  };
  useEffect(() => {
    if (refresh === true) {
      init();
      setRefresh(false);
    }
  }, [refresh]);

  const handlePageSize = async (e) => {
    setSize(e.target.value);
    setPage(0);
    await getSegments({ page_size: e.target.value, page: 0 });
  };
  const handlePagination = async (e, page) => {
    setPage(page - 1);
    await getSegments({ page_size: size, page: page - 1 });
  };

  useEffect(() => {
    analytics.triggerEvent(
      4625000234,
      "segments_page_load",
      "segments_page",
      "",
      {}
    );
    authStore.updateLeadDetailStatus();
    init();
  }, []);
  return (
    <>
      <Container>
        <Wrapper>
          <Row>
            <TopWrapper>
              <Header>Segments</Header>
            </TopWrapper>
            <ButtonWrapper>
              <Button
                onClick={() => {
                  analytics.triggerEvent(
                    4625000235,
                    "create_segment_button_tap",
                    "segments_page",
                    "create_segment_button",
                    {}
                  );
                  setOpenCreateSegmentForm(true);
                }}
                variant="contained"
                style={{
                  backgroundColor: "#185DD2",
                  color: "white",
                  textTransform: "none",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                <Add />
                Create Segment
              </Button>
            </ButtonWrapper>
            {/* <History style={{ height: "34px", width: "34px" }} /> */}
          </Row>
          {!loading ? (
            <Bottom>
              <TableWrapper>
                {row.length > 0 ? (
                  <TableContainer
                    component={Paper}
                    sx={{
                      width: "100%",
                      display: "table",
                      tableLayout: "fixed",
                    }}
                  >
                    <Table
                      size="small"
                      aria-label="a dense table"
                      sx={{ minWidth: "100%" }}
                    >
                      <TableHead
                        style={{ backgroundColor: "#EFEFF4", height: "40px" }}
                      >
                        <TableRow>
                          {SegmentListColumns.map((e) => {
                            return <TableCell>{e.headerName}</TableCell>;
                          })}
                          <TableCell>
                            <Text>Actions</Text>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row.map((e, i) => {
                          return (
                            <SegmentRowComponent
                              item={e}
                              idx={i}
                              refresh={refresh}
                              setRefresh={setRefresh}
                            />
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <>
                    <TableContainer
                      component={Paper}
                      sx={{
                        width: "100%",
                        display: "table",
                        tableLayout: "fixed",
                      }}
                    >
                      <Table
                        size="small"
                        aria-label="a dense table"
                        sx={{ minWidth: "100%" }}
                      >
                        <TableHead
                          style={{ backgroundColor: "#EFEFF4", height: "40px" }}
                        >
                          <TableRow>
                            {SegmentListColumns.map((e) => {
                              return <TableCell>{e.headerName}</TableCell>;
                            })}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {row.map((e, i) => {
                            return (
                              <SegmentRowComponent
                                item={e}
                                idx={i}
                                refresh={refresh}
                                setRefresh={setRefresh}
                              />
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <EmptyTableWrapper>
                      <EmptyText>No rows</EmptyText>
                    </EmptyTableWrapper>
                  </>
                )}
              </TableWrapper>
              <PaginationWrapper>
                <PaginationComponent
                  page_no={page}
                  row={row}
                  page_size={size}
                  size={size}
                  count={count}
                  handlePageSize={handlePageSize}
                  handlePage={handlePagination}
                />
              </PaginationWrapper>
            </Bottom>
          ) : (
            <SpinnerWrapper>
              <LoadingAnimationComponent size={"small"} />
            </SpinnerWrapper>
          )}
        </Wrapper>
      </Container>
      <Footer />
      {openCreateSegmentForm && (
        <Drawer
          anchor={"right"}
          open={openCreateSegmentForm}
          onClose={() => {
            setOpenCreateSegmentForm(false);
          }}
        >
          {
            <CreateSegmentSidePanel
              refresh={refresh}
              setRefresh={setRefresh}
              open={openCreateSegmentForm}
              setOpen={setOpenCreateSegmentForm}
            />
          }
        </Drawer>
      )}
    </>
  );
};

export default observer(ReportsPage);
